import { Outlet } from 'react-router-dom'

import I18nProvider from '@/i18n/I18nProvider'

export default () => {
  if (typeof document === 'undefined') {
    return <div />
  }
  return (
    <I18nProvider>
      <Outlet />
    </I18nProvider>
  )
}
